
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/media/news",
      function () {
        return require("private-next-pages/media/news/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/media/news"])
      });
    }
  